import { ReactNode } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { RadioButton } from '@/common/components/RadioButton/RadioButton';

export interface IControlledRadioButtonGroupProps<T extends FieldValues> {
  name: Path<T>;
  control?: Control<T>;
  title: string;
  options: Array<{
    label: ReactNode;
    description?: ReactNode;
    value: string;
    rightContent?: ReactNode;
  }>;
  disabled?: boolean;
}

export const ControlledRadioButtonGroup = <T extends FieldValues>({
  name,
  control,
  options,
  disabled,
  title,
  ...restProps
}: IControlledRadioButtonGroupProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, formState: { isSubmitting } }) => (
        <RadioButton.Group
          value={value}
          onChange={onChange}
          disabled={disabled || isSubmitting}
          title={title}
          {...restProps}
        >
          {options.map((option) => (
            <RadioButton.Option
              key={option.value}
              label={option.label}
              description={option.description}
              value={option.value}
              rightContent={option.rightContent}
            />
          ))}
        </RadioButton.Group>
      )}
    />
  );
};
